export const dbFields =
{
    id: {
        visiable: false,
        title: 'Id',
        key: 'id'
    },

    name: {
        visiable: true,
        title: 'Custom Name',
        key: 'name'
    },
    app_name1: {
        visiable: true,
        title: 'App1 Diaplay Name',
        key: 'app1_name'
    },
    app_name2: {
        visiable: true,
        title: 'App2 Diaplay Name',
        key: 'app2_name'
    },
    app_url1: {
        visiable: true,
        title: 'App1 URL',
        key: 'appmanifest1'
    },
    app_url2: {
        visiable: true,
        title: 'App2 URL',
        key: 'appmanifest2'
    },

    desc: {
        visiable: true,
        title: 'Description',
        key: 'desc'
    },
};
